import { Link, useParams } from 'react-router-dom';
import CustomTooltip from '../../common/Tooltip';
import useProductSelectionStore from '../../../stores/useProductSelectionStore';
import useMultiOpeningMatStore from '../../../stores/useMultiOpeningMatStore';

const ProductSelectionControls = ({ orderId }) => {
  const { lineItemId } = useParams();
  const { resetSelectedOptions, productType, resetEditMode } = useProductSelectionStore();
  const backPath = lineItemId
    ? `/lab-orders/${orderId}/summary`
    : `/product-selection/${orderId}`;

  const handleHomeClick = () => {
    resetEditMode();
    useMultiOpeningMatStore.getState().resetForm();
  };

  return (
    <div className="controls-block-container">
      <div className="controls-block-grid top">
        <CustomTooltip title="Back to products">
          <Link
            to={backPath}
            className="div-block-169-copy ghost"
            onClick={handleHomeClick}
            aria-label="Back to product selection"
          >
            <div className="icon small w-embed">
              <svg xmlns="http://www.w3.org/2000/svg" fill="#4a4a4a" viewBox="0 0 256 256">
                <rect width="256" height="256" fill="none" />
                <path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z" />
              </svg>
            </div>
          </Link>
        </CustomTooltip>
        {/* <CustomTooltip title="Reset All">
          <button
            type="button"
            className="div-block-169-copy ghost"
            aria-label="Reset All"
            onClick={resetSelectedOptions}
          >
            <div className="icon small w-embed">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" viewBox="0 0 256 256">
                <rect width="256" height="256" fill="none" />
                <path d="M216.001,207.833H130.34375l34.72949-34.72949.0166-.01465.01465-.0166,56.55371-56.55274a24.02962,24.02962,0,0,0,0-33.94141L176.40332,37.32324a24.0007,24.0007,0,0,0-33.94141,0L85.90283,93.88232l-.01025.00928-.00928.01026L29.32422,150.46094a24.00066,24.00066,0,0,0,0,33.9414l37.08887,37.08789a8.00232,8.00232,0,0,0,5.65722,2.34278H216.001a8,8,0,0,0,0-16ZM153.77637,48.6377a7.99708,7.99708,0,0,1,11.3125,0l45.25488,45.25488a8.00888,8.00888,0,0,1,0,11.31347l-50.91113,50.91114L102.86475,99.54932Z" />
              </svg>
            </div>
          </button>
        </CustomTooltip>
        <Link to={`/print-order/upload-more/${orderId}?productType=${encodeURIComponent(productType || 'default')}`} className="button-2 w-inline-block">
          <div className="icon right-margin w-embed">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentcolor" viewBox="0 0 256 256">
              <rect width="256" height="256" fill="none" />
              <path d="M128,23.99805a104,104,0,1,0,104,104A104.12041,104.12041,0,0,0,128,23.99805Zm40,112H136v32a8,8,0,1,1-16,0v-32H88a8,8,0,0,1,0-16h32v-32a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z" />
            </svg>
          </div>
          <div>Upload More</div>
        </Link> */}
      </div>
    </div>
  );
};

export default ProductSelectionControls;
